// Angular
require('angular');
require('angular-animate');
require('angular-messages');
require('angular-aria');
require('angular-material');
require('angular-ui-router');

require('angular-gettext');

// css
require('angular-material/angular-material.css');
require('material-design-icons/iconfont/material-icons.css');

require('clipboard');


//////////////////
// WEBPACK FOOTER
// ./app/vendor.js
// module id = 0
// module chunks = 2